import { getKnownTracker } from "../../lib/getKnownTracker";
import type { KnownTracker } from "../../lib/KnownTrackers";
import { urlToDomain } from "../../lib/utils/domains";
import { EventsTableAnalysisResults } from './EventsTableAnalysisResults';

export type TrackingCodeReportObserverInputs = Pick<EventsTableAnalysisResults, "searchResultsObserver" | "codeBehaviorsObserver">;

export const getTrackingCodeReportState = ({
	searchResultsObserver, codeBehaviorsObserver
}: TrackingCodeReportObserverInputs) => {
	if (codeBehaviorsObserver == null) return [];
	const pageDomains: string[] = [...new Set([
		...codeBehaviorsObserver.byPageDomainAndCodeUrl.keys(),
		...searchResultsObserver.byPageDomainAndCodeUrlAndDestinationDomain.keys()
	])].sort();
	return pageDomains.map(pageDomain => {
		const codeUrlToCodeBehaviors = codeBehaviorsObserver.byPageDomainAndCodeUrl.get(pageDomain);
		const codeUrlsToSearchResults = searchResultsObserver.byPageDomainAndCodeUrlAndDestinationDomain.get(pageDomain)?.byCodeUrl;
		const codeUrls = [...new Set([...(codeUrlToCodeBehaviors?.keys() ?? []), ...(codeUrlsToSearchResults?.keys() ?? [])]
		)]
			.filter((codeUrl) => ['http', 'ws'].find((protocol) => codeUrl.startsWith(protocol)) != null)
			.sort();
		return {
			pageDomain,
			byCodeUrl: codeUrls.map(codeUrl => {
				const knownTracker: KnownTracker | undefined = getKnownTracker(urlToDomain(codeUrl));
				const codeBehavior = codeUrlToCodeBehaviors?.get(codeUrl);
				const dataSentByDestinationDomain = codeUrlsToSearchResults?.get(codeUrl)?.byDestinationDomain ?? [];
				return { pageDomain, codeUrl, codeBehavior, knownTracker, dataSentByDestinationDomain };
			})
		};
	});
};
export type TrackingCodeReportState = ReturnType<typeof getTrackingCodeReportState>;